export default ({ condition, renderIf, renderElse = null }) => condition ? renderIf : renderElse;